export default "__VITE_ASSET__6T8tptfn__"